module.exports = __webpack_public_path__ + "static/media/golden_ticket.playngo.dd0f077c.jpeg";